module.exports = __webpack_public_path__ + "moneybag.1ba35d2a2b0ae16017d0576812f712d6.svg";